import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios';
import './registerServiceWorker'

import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import VueToasted from 'vue-toasted';
import VueTruncate from 'vue-truncate-filter';

/**
 * Begin: Vue2 Leaflet Global Settings.
 */
import { LMap, LTileLayer, LMarker } from 'vue2-leaflet';
import Vue2LeafletMarkercluster from 'vue2-leaflet-markercluster'
import 'leaflet/dist/leaflet.css'
import "leaflet.markercluster/dist/MarkerCluster.css";
import "leaflet.markercluster/dist/MarkerCluster.Default.css";
Vue.component('l-map', LMap)
Vue.component('l-tile-layer', LTileLayer)
Vue.component('l-marker', LMarker)
Vue.component('l-marker-cluster', Vue2LeafletMarkercluster);
delete L.Icon.Default.prototype._getIconUrl
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png')
})


/**
 * Use custom.css finally to override global styles.
 */
import './custom.scss'

Vue.use(BootstrapVue);
Vue.use(VueToasted);
Vue.use(VueTruncate);

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
